import {createContext,useContext} from 'react'
import type {DataResource} from './runtimeState'

const context=createContext<readonly DataResource[]>([])
export const CrmResourceAccessProvider=context.Provider
// This is server-reported read denial, never a grant or a substitute for RLS.
export function useCrmResourceDenied(resource:DataResource){return useContext(context).includes(resource)}
